import angular from 'angular';
import shoppingExperienceComponent from './shopping-experience.component';
 import ShoppingExperienceService from './shopping-experience.service';
 import shoppingExperienceConfig from './shopping-experience.config';

let shoppingExperienceModule = angular.module('app.shoppingExperience',[])
  .component('shoppingExperience', shoppingExperienceComponent)
   .service('ShoppingExperienceService', ShoppingExperienceService)
   .config(shoppingExperienceConfig)
  ;

export default shoppingExperienceModule;



// WEBPACK FOOTER //
// ./www/components/shopping-experience/shopping-experience.js